export const toFormData = async (s: string) => {
  const blob = await (await fetch(s)).blob();

  const formData = new FormData();

  formData.append("upload", blob);

  return formData;
};
